import { createSlice } from "@reduxjs/toolkit";
import { ClientCardsState } from "./clientCards";

interface IPaymentState {
  value: null | 0 | 1;
  title: string;
  card: ClientCardsState;
}

const initialState: IPaymentState = {
  value: 0,
  title: "Готівка",
  card: {
    cardMask: "",
    cardGuid: "",
  },
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPayment: (state, { payload }) => {
      state.value = payload.value;
      state.title = payload.title;
    },
    setCard: (state, { payload }) => {
      state.card = payload;
    },
    setDefaultPayment: () => {
      return initialState;
    },
  },
});

export const { setPayment, setCard, setDefaultPayment } = paymentSlice.actions;
export default paymentSlice.reducer;
